<template>
  <div>
    <v-container fluid v-if="!EditdialogUser && !AddVector">
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">{{ $t("PositiveQuestionSet") }}</h1>
            </v-col>
            
            <v-col cols="6" class="d-flex flex-wrap justify-end" style="display: flex; align-items: center;">
              <div class="custom-search-input-wrapper mr-3">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="modelgroup-field-search-setupgroupmodel" type="text" :placeholder="$t('_positiveQuestionSetName')"
                    :aria-label="$t('_positiveQuestionSetName')"
                    class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                    @click="searchName = ''">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
              <v-btn
                id="button-add-validationpositive"
                color="primary"
                class="control-btn create-btn customadd"
                variant="flat"
                size="large"
                prepend-icon="mdi-plus"
                rounded="xl"
                @click="Add()"
              >
                {{ $t('add') }}
                <v-tooltip activator="parent" location="top">{{ $t("_addNewPositiveQuestionSet") }}</v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loading"
          class="pa-5"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center;">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-validationpositive"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-img :src="images.editBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      {{ $t("edit") }}
                    </v-tooltip>
                  </v-btn>
            
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-popupedit-validationpositive"
                    variant="text"
                    density="comfortable"
                    @click="DeleteByName(item.id)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      {{ $t("delete") }}
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          <!-- Custom footer area -->
          <template v-slot:bottom>
            <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
              <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

              <v-data-table-footer v-model:items-per-page="itemsPerPage" :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)" />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>

    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t("loading") }}</h3>
          <p class="loading-subtitle">{{ $t("pleaseWait") }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">{{ $t("deleteConfirmation") }}</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            {{ $t("_confirmDeleteAllQuestions") }}
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo, { default as LogTrace } from "@/api/function.js"; // NOSONAR
import validationQuestionSetListMixin from "@/mixins/validationQuestionSetListMixin.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import deleteIcon from "@/assets/images/trash-solid.svg";
export default {
  name: "ValidationPositive",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace, validationQuestionSetListMixin],
  data: () => ({
    validationApis: {
      table: "GetTableValidationPositive",
      detailRoute: "ValidationPositiveDetail",
    },
    images: {
      edit: editImg,
      delete: deleteImg,
      editBtn: editBtn,
      deleteBtn: deleteBtn,
      deleteIcon: deleteIcon,
    },
    dialog_delete: false,
    deleteItem: null,
  }),
  computed: {
    headers() {
      return [
        { title: this.$t("no"), align: "center", sortable: false },
        {
          title: this.$t("PositiveQuestionSet"),
          align: "left",
          sortable: true,
          value: "Name",
        },
        {
          title: this.$t("createdBy"),
          align: "left",
          sortable: true,
          value: "CreateBy",
        },
        { title: this.$t("manage"), align: "center", sortable: false, width: "150px" },
      ];
    },
  },
  methods: {
    GetDefault() {
      this.dialog = true;
      this.loading = true;
      const { page, itemsPerPage } = this.options;
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : this.totalTable, // NOSONAR
        name: this.searchName,
        sortDesc: null,
        sortBy: null,
      };
      this.$call.GetTableValidationPositive(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
            this.options.page = temp.page;
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loading = false;
          this.dialog = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.loading = false;
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      this.isSearch = true;
      this.GetDefault();
    },
    DeleteByName(id) {
      this.deleteItem = id;
      this.dialog_delete = true;
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    confirmDelete(name) {
      if (!this.deleteItem) return;
      const id = this.deleteItem
      try {
              this.dialog = true;
              this.dialog_delete = false;
              this.$call.DeleteValidationPositive(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.$swal.fire({
                      title: this.$t("_successfullyDeleted"),
                      showConfirmButton: false,
                      timer: 1500,
                      position: 'top',
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                    this.Clear();
                    this.Get();
                  }
                  this.dialog = false;
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
  },
  mounted() {
    this.GetDate();
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}
.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
</style>
